import clsx from 'clsx';
import CheckCircleIcon from './check-circle-icon.svg?svgr';
import * as styles from './index.css';

const CheckmarkIcon = ({
  className,
  showIcon = false,
}: {
  className?: string;
  showIcon?: boolean;
}) => {
  return (
    <CheckCircleIcon
      aria-label="Check Circle Icon"
      className={clsx(styles.icon, showIcon && styles.showIcon, className)}
    />
  );
};

export default CheckmarkIcon;
